import { Outlet } from 'react-router-dom'
import { Box } from '@mui/material'
import PageTitle from '@/components/PageTitle'
import Drawer from '@/components/drawer/Drawer'
import useOverlay from '@/hooks/useOverlay'
import Breadcrumb from '@/components/breadcrumbs/Breadcrumb'
import { useFeatureFlagContext } from '@/feature_flags/FeatureFlagProvider'
import { useRootOrganization } from '@/components/organizations/RootOrganizationProvider'
import usePermission from '@/hooks/usePermission'
import SettingsNavigation from '@/components/settings-navigation/SettingsNavigation'

export default function GlobalSettingsPage() {
  const drawerOverlay = useOverlay({ initiallyOpen: true })
  const featureFlags = useFeatureFlagContext()
  const { rootOrganization } = useRootOrganization()
  const { hasEditingPermission } = usePermission()

  const canEditRootOrg = hasEditingPermission('edit_orgs', rootOrganization.id)

  const routes = [
    {
      to: 'my-profile',
      label: 'My Profile',
    },
    {
      to: 'my-preferences',
      label: 'My Preferences',
    },
    {
      to: 'teams',
      label: 'Teams',
    },
    {
      to: 'users',
      label: 'Users',
    },
    {
      to: 'organizations',
      label: 'Organizations',
    },
    {
      to: 'organization-types',
      label: 'Organization Types',
    },
    {
      to: 'lists',
      label: 'Lists',
    },
    {
      to: 'custom-variables',
      label: 'Custom Variables',
    },
  ]

  if (canEditRootOrg) {
    if (featureFlags.customer_page_visible) {
      routes.splice(2, 0, {
        to: `customer/${rootOrganization.id}`,
        label: 'Subscription Details',
      })
    }
    routes.splice(-1, 0, {
      to: 'credentials',
      label: 'Credentials',
    })
  }

  return (
    <>
      <PageTitle>Projects</PageTitle>
      <Breadcrumb label="Global Settings" url="/settings" />

      <Drawer overlay={drawerOverlay} size="sm" transparent>
        <SettingsNavigation label="Global Settings" routes={routes} />
      </Drawer>

      <Box sx={{ height: '100%', width: '100%', p: 2, pt: 3 }}>
        <Outlet />
      </Box>
    </>
  )
}
